export const CONSENT_KEY = "vitura.analytics-consent.v1";
export const CONSENT_EVENT = "vitura-analytics-consent";
const MAX_AGE = 180 * 24 * 60 * 60 * 1000;
const DENIAL_COOKIE = "vitura_analytics_denied";
let blockedForVisit = false;

export const hasPrivacySignal = () => navigator.globalPrivacyControl === true;

export function readAnalyticsConsent() {
  if (blockedForVisit || hasPrivacySignal()) return "denied";
  if (document.cookie.split("; ").includes(`${DENIAL_COOKIE}=1`)) return "denied";
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    if (raw === null) return "default";
    const record = JSON.parse(raw);
    const age = Date.now() - record?.updatedAt;
    // Never silently expire an opt-out into default-on collection.
    if (record?.version === 1 && record.choice === "denied") return "denied";
    return record?.version === 1 && record.choice === "granted" && age >= 0 && age < MAX_AGE ? "granted" : "denied";
  } catch { return "denied"; }
}

export const analyticsAllowed = () => ["default", "granted"].includes(readAnalyticsConsent());

export function saveAnalyticsConsent(choice) {
  if (hasPrivacySignal()) choice = "denied";
  blockedForVisit = choice !== "granted";
  try {
    const value = JSON.stringify({ version: 1, choice, updatedAt: Date.now() });
    localStorage.setItem(CONSENT_KEY, value);
    if (localStorage.getItem(CONSENT_KEY) !== value) throw new Error("Storage unavailable");
    document.cookie = `${DENIAL_COOKIE}=; Max-Age=0; Path=/; SameSite=Lax; Secure`;
    blockedForVisit = false;
    window.dispatchEvent(new Event(CONSENT_EVENT));
    return true;
  } catch {
    blockedForVisit = true;
    // A failed withdrawal must not resurrect an older grant on the next visit.
    document.cookie = `${DENIAL_COOKIE}=1; Max-Age=${MAX_AGE / 1000}; Path=/; SameSite=Lax; Secure`;
    window.dispatchEvent(new Event(CONSENT_EVENT));
    return false;
  }
}

const isAnalyticsKey = key => /^(ph_|__ph_opt_|__posthog)/.test(key);
export function clearAnalyticsStorage() {
  for (const name of ["localStorage", "sessionStorage"]) {
    try {
      const storage = window[name];
      Object.keys(storage).filter(isAnalyticsKey).forEach(key => storage.removeItem(key));
    } catch { /* Storage can be unavailable; analytics stays disabled. */ }
  }
  const host = window.location.hostname.split(".");
  const paths = ["/", ...window.location.pathname.split("/").filter(Boolean).map((_, index, parts) => `/${parts.slice(0, index + 1).join("/")}`)];
  const domains = ["", ...host.map((_, index) => host.slice(index).join("."))];
  document.cookie.split(";").forEach(cookie => {
    const key = cookie.split("=")[0].trim();
    if (!isAnalyticsKey(key)) return;
    for (const path of paths) for (const domain of domains) {
      document.cookie = `${key}=; Max-Age=0; Path=${path};${domain ? ` Domain=${domain};` : ""} SameSite=Lax; Secure`;
    }
  });
}